module.exports = __webpack_public_path__ + "img/g-paper-clicks-logo-white.d7cba425.svg";